import React from "react";
import "./Our_Services.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCamera,
  faUserTie,
  faUtensils,
  faPalette,
  faMusic,
} from "@fortawesome/free-solid-svg-icons";

function Our_Services() {
  const services = [
    {
      icon: faCamera,
      name: "Photography & Videography",
      description:
        "Capture every special moment with professional photography and cinematic videos.",
    },
    {
      icon: faUserTie,
      name: "Bridal & Grooming",
      description:
        "Professional makeup and grooming services for your special day.",
    },
    {
      icon: faUtensils,
      name: "Catering & Dinner",
      description:
        "Delicious food and premium catering services for all events.",
    },
    {
      icon: faPalette,
      name: "Event Decoration",
      description:
        "Creative and theme-based decorations to enhance your event.",
    },
    {
      icon: faMusic,
      name: "Music & Entertainment",
      description: "DJ, live music, and entertainment for an energetic event.",
    },
  ];

  return (
    <section className="our_services_section py-5">
      <div className="container text-center">
        <h2 className="our_services_heading mb-3">Our Event Services</h2>

        <p className="our_services_subtext mb-5">
          We provide complete event solutions to make your celebration
          memorable.
        </p>

        <div className="row g-4 justify-content-center">
          {services.map((service, index) => (
            <div
              key={index}
              className="col-12 col-lg-2 col-md-6 col-sm-6 custom_col"
            >
              <div className="our_service_card h-100 p-4 text-center">
                <div className="our_service_icon_wrap mb-3">
                  <FontAwesomeIcon
                    icon={service.icon}
                    className="our_service_icon"
                  />
                </div>

                <h5 className="our_service_title">{service.name}</h5>
                <p className="our_service_desc">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Our_Services;
